export interface ngxCmDropdownDataModel {
    id: string | number,
    name: string,
    imageUrl?: string
}

export * from "./ngx-modal.model";
export * from "./ngx-module.info";
export * from "./ngx.module.config";
export * from "./ngx-auth-provider";